import React, { useEffect, useState } from "react";
import "./style.scss";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Tabination from "../../reusableComponents/Tabs/index";
import ProfileContent from "../../components/Profile";
import Overview from "./Overview";
import GetLink from "./GetLink";
import CommissionHistory from "./CommissionHistory/CommissionHistory";

const Affiliate = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const items = [
    {
      name: "Overview",
      path: "overview",
    },
    {
      name: "Get a Link",
      path: "get-a-link",
    },
    {
      name: "Commission History",
      path: "commission-history",
    },
  ];
  const [activeTab, setActiveTab] = useState();
  const location_path = useLocation();

  const pathnameSegments = location_path.pathname.split("/");
  const desiredPart = pathnameSegments[2];
  useEffect(() => {
    const currentLocation = "/" + desiredPart;
    switch (currentLocation) {
      case "/overview":
        setActiveTab(0);
        break;

      case "/get-a-link":
        setActiveTab(1);
        break;
      case "/commission-history":
        setActiveTab(2);
        break;

      default:
    }
  }, [window.location.pathname]);
  return (
    <div className="affiliate-page-wrapper">
      <Tabination
        variant={1}
        tabItems={items}
        showTabs={true}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        mainurl={"/affiliate/"}
      />
      <div className="affiliate-page">
        <Routes>
          <Route path="/" element={<Navigate to="overview" replace={true} />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/get-a-link" element={<GetLink />} />
          <Route path="/commission-history" element={<CommissionHistory />} />
        </Routes>
      </div>
    </div>
  );
};

export default Affiliate;
